



















































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentFileThumbnailType } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import useVaultView from "@/hooks/useVaultView";
import { isAttachmentFile } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import { AttachmentFile, PostFileData } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import PostFilePreview from "@/components/PostCreate/components/PostFilePreview";
import VaultModal from "@/components/VaultModal";

export default defineComponent({
  name: "PostThumbnails",
  components: {
    BaseIcon,
    BaseIconButton,
    PostFilePreview,
    BaseInputFileWithPreview,
    VaultModal,
  },
  props: {
    files: { type: Array as PropType<PostFileData[]>, required: true },
    thumbnailType: { type: String as PropType<ContentFileThumbnailType>, required: true },
  },
  setup(props, { emit }) {
    const { isVaultAvailable, showPrivateVault: showVault, showVaultOrNative } = useVaultView();

    const loading = ref(false);

    const title = computed(() =>
      props.thumbnailType === ContentFileThumbnailType.SFW ? $t("SFW thumbnail") : $t("NSFW thumbnail")
    );
    const subtitle = computed(() =>
      props.thumbnailType === ContentFileThumbnailType.SFW
        ? $t("Visible to everyone")
        : $t("Shown only when NSFW mode is on")
    );

    const postSubject = {
      subjectId: "0",
      subjectType: VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS,
    };

    const onAddFiles = (files: (AttachmentFile | File)[]) => {
      loading.value = true;
      const options = {
        publicAccess: true,
        thumbnailType: props.thumbnailType,
        cb: () => (loading.value = false),
      };
      if (files.every(isAttachmentFile)) {
        emit("addFilesFromVault", files, options);
      } else {
        emit("addFiles", files, options);
      }
    };

    const onNativeAddFileHandler = (files: FileList) => {
      onAddFiles(Array.from(files));
    };

    return {
      title,
      subtitle,
      loading,
      isVaultAvailable,
      showVault,
      postSubject,
      showVaultOrNative,
      onNativeAddFileHandler,
      onAddFiles,
    };
  },
});
